import { Component, Vue } from "vue-property-decorator";
import { i18n } from "@/resources/locales";
@Component({})
export default class CallEvents extends Vue {
  async onCameraOrSoundDisabled() {
    const videoDevices = [];
    const audioDevices = [];
    let showNotification = false;
    let descriptionNotification = "";
    let noCamera = false;

    const deviceList = await navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => devices);
    const mediaDevicesList = JSON.parse(JSON.stringify(deviceList));
    mediaDevicesList.forEach((dev) => {
      if (dev.kind === "videoinput") videoDevices.push(dev);
      if (dev.kind === "audioinput") audioDevices.push(dev);
    });

    await navigator.mediaDevices
      .getUserMedia({ audio: true, video: true })
      .then(function (stream) {})
      .catch(function (error) {
        if (videoDevices.length > 0) {
          descriptionNotification = `${i18n.t(
            "notifications.devices.permissionDenied"
          )}`;
          showNotification = true;
        }
      });

    await this.closeDeviceNotification();

    const isFirefox = /^((?!chrome|android).)*firefox/i.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    // Busca el estado de los permisos
    if (navigator != undefined && navigator.permissions != undefined) {
      if (!isFirefox && !isSafari) {
        const cam = "camera" as PermissionName;
        const cameraPermission = await navigator.permissions.query({
          name: cam,
        });
        const mic = "microphone" as PermissionName;
        const microphonePermission = await navigator.permissions.query({
          name: mic,
        });
        if (
          cameraPermission.state === "denied" ||
          microphonePermission.state === "denied" ||
          cameraPermission.state === "prompt" ||
          microphonePermission.state === "prompt"
        ) {
          descriptionNotification = `${i18n.t(
            "notifications.devices.permissions"
          )}`;
          showNotification = true;
        }
        if (cameraPermission.state !== "denied" && videoDevices.length <= 0) {
          noCamera = true;
          // No hay camaras disponibles
          descriptionNotification = `${i18n.t(
            "notifications.devices.withoutDevices",
            {
              devices: i18n.t("notifications.devices.devices1"),
            }
          )}`;
          showNotification = true;
        }
        if (
          microphonePermission.state !== "denied" &&
          audioDevices.length <= 0
        ) {
          // No hay microfonos disponibles
          descriptionNotification = `${i18n.t(
            "notifications.devices.withoutDevices",
            {
              devices: noCamera
                ? i18n.t("notifications.devices.devices3")
                : i18n.t("notifications.devices.devices2"),
            }
          )}`;
          showNotification = true;
        }
      }
      if (isFirefox || isSafari) {
        navigator.mediaDevices
          .getUserMedia({ video: true, audio: true })
          .then(async () => {
            if (videoDevices.length <= 0) {
              noCamera = true;
              // No hay camaras disponibles
              descriptionNotification = `${i18n.t(
                "notifications.devices.withoutDevices",
                {
                  devices: i18n.t("notifications.devices.devices1"),
                }
              )}`;
              showNotification = true;
            }
            if (audioDevices.length <= 0) {
              // No hay microfonos disponibles
              descriptionNotification = `${i18n.t(
                "notifications.devices.withoutDevices",
                {
                  devices: noCamera
                    ? i18n.t("notifications.devices.devices3")
                    : i18n.t("notifications.devices.devices2"),
                }
              )}`;
              showNotification = true;
            }
          })
          .catch(async () => {
            descriptionNotification = `${i18n.t(
              "notifications.devices.permissions"
            )}`;
            showNotification = true;
          });
      }
    }

    if (showNotification) {
      const notification = this.$vs.notification({
        sticky: true,
        buttonClose: true,
        duration: "none",
        clickClose: true,
        position: "bottom-center",
        color: "danger",
        title: i18n.t("notifications.devices.title"),
        text: descriptionNotification,
      });

      await this.$store.dispatch(
        "SystemStore/setDeviceNotificationAction",
        notification
      );
    }
  }
  async closeDeviceNotification() {
    const notification =
      this.$store.getters["SystemStore/getDeviceNotification"];
    if (notification) notification.close();
    await this.$store.dispatch("SystemStore/setDeviceNotificationAction", null);
  }
}
